import type { Theme } from '../../types/common'
import Icon from '../icon'

interface ThemeSwitchProps {
  theme: Theme
}

const ThemeSwitch = ({ theme }: ThemeSwitchProps) => {
  return (
    <div
      className="flx-ctr bg-secondary w-[50px] h-[50px] transition-all duration-[0.2s] ease-[ease-in-out] flex mt-[5px] rounded-[7px] hover:scale-105"
      id="theme-switch">
      {theme === 'dark' ? (
        <Icon
          className="pointer-events-none"
          id="moon"
          width="25"
          height="25"
          color="#fff"
        />
      ) : (
        <Icon
          className="pointer-events-none"
          id="sun"
          width="31"
          height="31"
          color="#0e091e"
        />
      )}
    </div>
  )
}

export default ThemeSwitch
